import React from 'react'

import styled from '@emotion/styled'
import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading4,
  Heading5,
  JustifyContent,
} from '@gousto-internal/citrus-react'

const CountdownContainer = styled(Box)`
  display: flex;
  background: #516272;
  border-radius: 4px;
  width: 100%;
  flex-wrap: wrap;
  overflow: hidden;
  padding: 14px 14px 10px;

  @media (min-width: 886px) {
    grid-template-columns: repeat(4, 1fr);
  }
`

const CountdownItem = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`

const CountdownNumber = styled(Heading5)`
  font-weight: 700;
  line-height: 1;
  margin-bottom: 5px;
  width: 100%;
  text-align: center;

  &.is-last {
    border-right: none;
  }

  &:not(.is-last) {
    border-right: 1px solid #afb7c1;
  }
`

const CountdownLabel = styled(Body2)`
  opacity: 0.8;
  font-weight: 400;
`

interface Props {
  days: number
  hours: number
  minutes: number
  seconds: number
}

export const RAFBoostCountdown = ({ days, hours, minutes, seconds }: Props) => (
  <Box
    display={Display.Flex}
    justifyContent={JustifyContent.Center}
    alignItems={AlignItems.Center}
    width="100%"
    paddingBottom={14}
  >
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      alignItems={AlignItems.Center}
      width="100%"
    >
      <Box paddingBottom={4}>
        <Heading4 color={Color.White}>Offer ends in</Heading4>
      </Box>
      <CountdownContainer>
        <CountdownItem>
          <CountdownNumber size={9} color={Color.White} data-testid="countdown-number">
            {days}
          </CountdownNumber>
          <CountdownLabel color={Color.White}>Days</CountdownLabel>
        </CountdownItem>

        <CountdownItem>
          <CountdownNumber size={9} color={Color.White} data-testid="countdown-number">
            {hours}
          </CountdownNumber>
          <CountdownLabel color={Color.White}>Hours</CountdownLabel>
        </CountdownItem>

        <CountdownItem>
          <CountdownNumber size={9} color={Color.White} data-testid="countdown-number">
            {minutes}
          </CountdownNumber>
          <CountdownLabel color={Color.White}>Minutes</CountdownLabel>
        </CountdownItem>

        <CountdownItem>
          <CountdownNumber
            size={9}
            color={Color.White}
            data-testid="countdown-number"
            className="is-last"
          >
            {seconds}
          </CountdownNumber>
          <CountdownLabel color={Color.White}>Seconds</CountdownLabel>
        </CountdownItem>
      </CountdownContainer>
    </Box>
  </Box>
)
